import React from 'react';

import Hero from 'components/hero';
import { FerretView } from 'components/ferret/Ferret';
import useFerretData from 'components/ferret/hooks/useFerretData';
import { HeroWithFerretProps } from './HeroWithFerret.props';
import { getHeroTitleProps } from './HeroWithFerret.utils';

function HeroWithFerret({
  translations,
  title,
  theme,
}: HeroWithFerretProps): React.ReactElement {
  const ferretData = useFerretData();
  const heroTitleProps = getHeroTitleProps(
    title,
    translations,
    ferretData.route
  );

  return (
    <React.Fragment>
      <Hero {...heroTitleProps} />
      <FerretView
        data={ferretData}
        translations={translations}
        margin={ferretData.isMobile ? '-56px' : '-96px'}
        theme={theme}
      />
    </React.Fragment>
  );
}

export default HeroWithFerret;
